import { render, staticRenderFns } from "./ProfitPreviewContent.vue?vue&type=template&id=763a7d28&scoped=true&"
import script from "./ProfitPreviewContent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProfitPreviewContent.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProfitPreviewContent.vue?vue&type=style&index=0&id=763a7d28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763a7d28",
  null
  
)

export default component.exports